import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';
import { FormattedMessage } from 'react-intl';


const FallbackUIModal = props => {

    const handleHideClick = () => props.actions.hideModal();

    return (
        <Fragment>
            <h5>
                {'Needed type of Modal has\'t been provided'}
                <br/>
                <Button onClick={handleHideClick}>
                    <FormattedMessage id='button.close'/>
                </Button>
            </h5>
        </Fragment>
    );
};

export default FallbackUIModal;
